import {sizeOfArray} from "@acng/frontend-bounty";
import {Error, ReferenceError} from "@acng/frontend-bounty/types";

import {RESOURCE_HIDDEN, RESOURCE_LOADER, UUID_STARGAZER_LOADER} from "../model/resource.js";
import {find} from "./find.js";
import {compile} from "./compile.js";
import {insert} from "./insert.js";

const MODULE = "stargazer/lookup";

/**
 * @typedef {import("../model/resource.js").ResourceElement} ResourceElement
 */

/**
 * @param {ResourceElement} namespace
 * @param {string[]} path
 */
export const lookup = async (namespace, path) => {
  if (namespace[RESOURCE_HIDDEN]) {
    throw namespace;
  }

  let resource = find(namespace, path, true);

  if (!resource) {
    // TODO try ... catch
    await fetch(namespace, ...path);

    resource = find(namespace, path, true);

    if (!resource) {
      // TODO Custom Error
      throw ReferenceError(UUID_STARGAZER_LOADER);
    }
  }

  await compile(resource);

  return resource;
};

/**
 * @todo TODO Since the insert is synchronous loader could return a promise now which resolves to item or null (caching in core must be changed for that)
 *
 * @param {ResourceElement} namespace
 * @param {string[]} path
 * @returns {Promise<boolean>}
 */
const fetch = async (namespace, ...path) => {
  const [id, ...rest] = path;
  ASSERT: if (!id) {
    console.error(namespace, path);
    throw Error();
  }

  const nextNamespace = find(namespace, [id]);

  if (nextNamespace && sizeOfArray(rest) && (await fetch(nextNamespace, ...rest))) {
    return true;
  }

  const loader = namespace[RESOURCE_LOADER];
  if (loader) {
    await loader(path, (item) => insert(namespace, item, path));
    return true;
  }

  return false;
};
